"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault")["default"];
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.Rule = void 0;
var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));
var _find = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/find"));
var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));
var _stringify = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/json/stringify"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));
var _Variant = require("./Variant");
var _RuleMeasure = require("./RuleMeasure");
var Rule = /*#__PURE__*/function () {
  function Rule(json) {
    (0, _classCallCheck2["default"])(this, Rule);
    this.hasdivider = 0;
    this.hasCloset = 0;
    this.measures = [];
    if (!json) throw 'Data to build rule object is undefined';
    if (!json.hasOwnProperty('model') || !json.hasOwnProperty('neutro') || !json.hasOwnProperty('item') || !json.hasOwnProperty('cModel') || !json.hasOwnProperty('desModel') || !json.hasOwnProperty('desItem')) throw 'Can\'t build a rule object from a service that return onlyVariati';
    this.reg = json.reg;
    this.l = json.l;
    this.a = json.a;
    this.p = json.p;
    this.nl = json.nl;
    this.na = json.na;
    this.np = json.np;
    this.ul = json.ul;
    this.ua = json.ua;
    this.up = json.up;
    this.vincoli = json.vincoli;
    this.extraEval = json.extraEval;
    this.buttons = json.buttons;
    this.agg = json.agg;
    this.curagg = json.curagg;
    this.aggbtn = json.aggbtn;
    this.complete = json.complete;
    this.altezze = json.altezze;
    this.posmode = json.posmode;
    this.visible = json.visible;
    this.hasdivider = json.hasdivider;
    this.lato = json.lato;
    this.latodes = json.latodes;
    this.img = json.img;
    if (json.hasdivider) {
      this.hasdivider = json.hasdivider;
      this.divider = json.divider;
      this.divset = json.divset;
    }
    this.model = json.model;
    this.neutro = json.neutro;
    this.item = json.item;
    this.cModel = json.cModel;
    this.desModel = json.desModel;
    this.desItem = json.desItem;
    this.flmoda = json.flmoda;
    this.flmodp = json.flmodp;
    this.flmodl = json.flmodl;
    this.modoAdd = json.modoAdd;
    if (json.rows) this.setVariantRows(json.rows);
    this.setMeasures(json.vincoli);
    this.checkFields(json);
  }
  (0, _createClass2["default"])(Rule, [{
    key: "setVariantData",
    value: function setVariantData(data) {
      var mode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      if (data) {
        if (data.reg) {
          this.reg = data.reg;
        }
        this.l = data.l;
        this.a = data.a;
        this.p = data.p;
        this.agg = data.agg;
        if (mode || data.complete) {
          if (data.hasdivider) {
            this.divider = data.divider;
            this.divset = data.divset;
          }
          this.setVariantRows(data.rows);
        } else {
          this.mergeHeaderRows(data.rows);
          if (data.hasdivider) {
            this.divider = data.divider;
            this.divset = data.divset;
          }
        }
      }
    }
  }, {
    key: "mergeHeaderRows",
    value: function mergeHeaderRows(rows) {
      var _this = this;
      if (rows) {
        if (!this.rows) this.rows = [];
        (0, _forEach["default"])(rows).call(rows, function (row) {
          var _context;
          var variant = (0, _find["default"])(_context = _this.rows).call(_context, function (x1) {
            return row.id === x1.id;
          });
          if (variant) variant.mergeJson(row);else console.error('Missing variant with id ' + row.id + ' from original rule');
        });
      }
    }
  }, {
    key: "getForced",
    value: function getForced() {
      var _context2;
      return (0, _filter["default"])(_context2 = this.rows).call(_context2, function (r) {
        return r.obbligate === true;
      });
    }
  }, {
    key: "hasForced",
    value: function hasForced() {
      return this.getForced().length > 0;
    }
  }, {
    key: "checkFields",
    value: function checkFields(json) {
      var _context3,
        _this2 = this;
      (0, _map["default"])(_context3 = (0, _keys["default"])(json)).call(_context3, function (key) {
        if (!_this2.hasOwnProperty(key)) console.warn('%c' + key + '%c is ignored in Rule class', 'color: blue', 'color: inherit');
      });
    }
  }, {
    key: "clone",
    value: function clone() {
      var newRule = new Rule(this);
      newRule.setVariantRows(JSON.parse((0, _stringify["default"])(this.rows)));
      newRule.setMeasures(JSON.parse((0, _stringify["default"])(this.vincoli)));
      return newRule;
    }
  }, {
    key: "setVariantRows",
    value: function setVariantRows(rowVariants) {
      this.rows = [];
      for (var i = 0; i < rowVariants.length; i++) {
        if (rowVariants[i].cod == "_ISCLOSET") {
          this.hasCloset = 1;
        }
        var variant = new _Variant.Variant(rowVariants[i]);
        this.rows.push(variant);
      }
    }
  }, {
    key: "getVariantById",
    value: function getVariantById(id) {
      var _context4;
      var variant = (0, _find["default"])(_context4 = this.rows).call(_context4, function (x) {
        return x.id == id;
      });
      return variant;
    }
  }, {
    key: "setMeasures",
    value: function setMeasures(vincoli) {
      this.measures = [];
      var hasVincoli = !!vincoli;
      this.measures.push(new _RuleMeasure.RuleMeasure('L', this.l, hasVincoli ? vincoli.flmodl === "N" : false, !hasVincoli ? null : {
        inidim: vincoli.inidim.x,
        min: vincoli.min.x,
        max: vincoli.max.x
      }));
      this.measures.push(new _RuleMeasure.RuleMeasure('A', this.a, hasVincoli ? vincoli.flmoda === "N" : false, !hasVincoli ? null : {
        inidim: vincoli.inidim.y,
        min: vincoli.min.y,
        max: vincoli.max.y
      }));
      this.measures.push(new _RuleMeasure.RuleMeasure('P', this.p, hasVincoli ? vincoli.flmodp === "N" : false, !hasVincoli ? null : {
        inidim: vincoli.inidim.z,
        min: vincoli.min.z,
        max: vincoli.max.z
      }));
    }
  }], [{
    key: "joinvariants",
    value: function joinvariants(s) {
      var vv = [];
      if (s) (0, _forEach["default"])(s).call(s, function (x) {
        vv.push(x.codvar + '=' + x.codopz);
      });
      return vv.join(';');
    }
  }]);
  return Rule;
}();
exports.Rule = Rule;
//# sourceMappingURL=Rule.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@3cad/nextcore/lib/commonjs/classes/Rule.js
// module id = 135
// module chunks = 142